<script lang="ts">
  import { onMount } from "svelte";
  import Tab from "../../components/Tab/Tab.svelte";
  import Tabs from "../../components/Tab/Tabs.svelte";
  import { navigate } from "../../app.logic";

  enum ChallengePage {
    Detail = 1,
    Tasks,
  }

  export let challengeId: number;
  export let tasks: boolean;

  let currentTab: ChallengePage = ChallengePage.Detail;

  onMount(() => {
    currentTab = tasks ? ChallengePage.Tasks : ChallengePage.Detail;
  });
</script>

<Tabs>
  <Tab
    label="Detail"
    active={currentTab == ChallengePage.Detail}
    on:click={(_) => {
      navigate(`/challenge/${challengeId}`);
    }}
  />
  {#if challengeId > 0}
    <Tab
      label="Tasks"
      active={currentTab == ChallengePage.Tasks}
      on:click={(_) => {
        navigate(`/challenge/${challengeId}/tasks`);
      }}
    />
  {/if}
</Tabs>
